import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/selectorg',
		name: 'selectorg',
		component: () => import('../views/ysqgk/selectorg.vue'),
		meta: {
			title: '依申请公开'
		}
	},
	{
		path: '/formgr',
		name: 'formgr',
		component: () => import('../views/ysqgk/formgr.vue'),
		meta: {
			title: '依申请公开'
		}
	},
	{
		path: '/formqy',
		name: 'formqy',
		component: () => import('../views/ysqgk/formqy.vue'),
		meta: {
			title: '依申请公开'
		}
	},
	{
		path: '/wxts',
		name: 'wxts',
		component: () => import('../views/ysqgk/wxts.vue'),
		meta: {
			title: '依申请公开'
		}
	},
	{
		path: '/selecttype',
		name: 'selecttype',
		component: () => import('../views/ysqgk/selecttype.vue'),
		meta: {
			title: '依申请公开'
		}
	},
	{
		path: '/search',
		name: 'search',
		component: () => import('../views/ysqgk/search.vue'),
		meta: {
			title: '依申请公开'
		}
	},
	{
		path: '/detail',
		name: 'detail',
		component: () => import('../views/ysqgk/detail.vue'),
		meta: {
			title: '依申请公开'
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: '/ysqgk/',
	routes
})

export default router